import React from "react";
import ReactDOM from "react-dom";
import App from "./App.tsx";
import DOMReady from "./components/helpers/domReady";
import * as serviceWorker from "./serviceWorker";
import fetchKeys from "./components/utils/fetchKeys";
import { getAndSetData } from "./components/utils/editUpdateStorage";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";
import "./public/css/global.scss";
import "./index.css";

fetchKeys(() => {
  DOMReady();
  getAndSetData(); // Set localstorage data to global variable if there

  ReactDOM.render(<App />, document.getElementById("root"));
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
